import { PLANS } from '../hooks/useBilling'

export const naira = (n) => '₦' + Number(n || 0).toLocaleString('en-NG')

export const planDef = (tier) => PLANS.find((p) => p.tier === tier)

export const daysLeft = (date) => Math.ceil((date.getTime() - Date.now()) / 86_400_000)

// Access state for an org card/row: paying > trial countdown > lapsed.
export function orgAccess(org) {
  if (org.subscriptionStatus === 'comped') return { key: 'comped', label: 'Comped', cls: 'bg-purple-100 text-purple-700' }
  if (org.subscriptionStatus === 'active') return { key: 'active', label: 'Active', cls: 'bg-green-100 text-green-700' }
  if (org.subscriptionStatus === 'past_due') return { key: 'past_due', label: 'Past due', cls: 'bg-red-100 text-red-700' }
  if (org.subscriptionStatus === 'cancelled') return { key: 'cancelled', label: 'Cancelled', cls: 'bg-gray-200 text-gray-600' }
  if (!org.trialEndsAt) return { key: 'no_trial', label: 'No trial set', cls: 'bg-gray-100 text-gray-500' }
  const d = daysLeft(org.trialEndsAt)
  if (d < 0) return { key: 'expired', label: `Trial expired ${-d}d ago`, cls: 'bg-red-100 text-red-700' }
  if (d <= 7) return { key: 'ending', label: `Trial: ${d}d left`, cls: 'bg-amber-100 text-amber-700' }
  return { key: 'trialing', label: `Trial: ${d}d left`, cls: 'bg-blue-100 text-blue-700' }
}

// Orgs that should surface on the Overview "needs attention" list.
export function needsAttention(org) {
  return ['past_due', 'cancelled', 'expired', 'ending'].includes(orgAccess(org).key)
}

// Monthly recurring revenue: paying orgs only, priced from the PLANS catalogue.
export function orgMrr(org) {
  return org.subscriptionStatus === 'active' ? (planDef(org.plan)?.amount ?? 0) : 0
}

const PLAN_COLORS = {
  starter: 'bg-gray-100 text-gray-600',
  growth: 'bg-blue-100 text-blue-700',
  enterprise: 'bg-teal-100 text-teal-700',
}

export function PlanBadge({ plan }) {
  return (
    <span className={`inline-block px-2 py-0.5 rounded-md text-xs font-bold capitalize ${PLAN_COLORS[plan] || PLAN_COLORS.starter}`}>
      {plan || 'starter'}
    </span>
  )
}

export function StatusChip({ org }) {
  const a = orgAccess(org)
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${a.cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {a.label}
    </span>
  )
}

export function Card({ title, hint, children, className = '' }) {
  return (
    <div className={`bg-white rounded-xl shadow border border-gray-100 ${className}`}>
      {title && (
        <div className="flex items-center px-4 py-3 border-b border-gray-100">
          <h3 className="text-sm font-bold text-gray-800">{title}</h3>
          {hint && <span className="ml-auto text-xs text-gray-400">{hint}</span>}
        </div>
      )}
      {children}
    </div>
  )
}

export function Kpi({ label, value, sub, valueClass = 'text-gray-800' }) {
  return (
    <div className="bg-white rounded-xl shadow border border-gray-100 px-4 py-3.5">
      <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400">{label}</p>
      <p className={`text-2xl font-bold tabular-nums mt-1 ${valueClass}`}>{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-0.5">{sub}</p>}
    </div>
  )
}
